
import { fetch } from 'fishx';
import get from 'lodash/get';
import { getCookie } from './utils';
// import { message } from '@whalecloud/fdx';
// import { connect } from 'react-redux';


export function getWebRoot() {
  let webroot = document.location.href;
  if (webroot.indexOf('#') < 0) {
    if (window.top && window.top.document.location.href.indexOf('portal') >= 0) {
      webroot = window.top.document.location.href;
    } else {
      return SEFT_BASE_NAME;
    }
  }
  webroot = webroot.substring(webroot.indexOf('//') + 2, webroot.length);
  webroot = webroot.substring(webroot.indexOf('/') + 1, webroot.length);
  webroot = webroot.indexOf('#') === webroot.length - 1 ? webroot.substring(0, webroot.indexOf('#')) : webroot;
  webroot = webroot.indexOf('/') > -1 ? webroot.substring(0, webroot.indexOf('/')) : webroot;
  webroot = webroot.replace('index.html', '');
  webroot = webroot === '#' ? '' : `${webroot}/drm`;
  const rootpath = webroot.length <= 0 ? '' : `/${webroot}`;
  return rootpath;
}

export function getRequestPrefix() {
  const rootpath = getWebRoot();

  // 当处于开发环境或者分离部署的时候需要统一加上 /api 前缀
  // eslint-disable-next-line no-undef
  if ((process.env && process.env.NODE_ENV === 'development') || SEPARATION_FLAG) {
    return `${rootpath}/api`;
  }
  return rootpath;
}

export default function request(url, option) {
  const urlN = `${getRequestPrefix()}${url}`;
  return fetch(urlN, { ...option, headers: { zoneCode: getCookie('getCookie') || '' } }).then(response => {
    const isError = get(response, 'success') === false;
    if (isError) {
      const code = get(response, 'data.code');
      if (code === 'S-SYS-00027') {
        Fishx.history.push('/userLogin');
      }
      // 不规范的抛错，以及框架类型的接口的抛错
      return response;
    }
    const result = {
      success: true,
      data: response,
      errorMsg: undefined,
    };
    return result;
  });
}
